/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint import/prefer-default-export: 0  */

import * as form from '../form';

export const historyEmployment = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    const reprimand = xitem.Reprimand || {};

    const phoneNumbers = ((xitem.PhoneNumbers || {}).items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Telephone: form.telephone(yitem.Telephone),
        },
      };
    });

    const emails = ((xitem.Emails || {}).items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Email: form.email(yitem.Email),
        },
      };
    });

    const websites = ((xitem.Websites || {}).items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Email: form.text(yitem.Website),
        },
      };
    });

    const dismissalItem = function (data = {}) {
      return form.general('dismissal.item', {
        Date: form.datecontrol(data.Date),
        DateNotApplicable: form.notapplicable(data.DateNotApplicable),
        Description: form.textarea(data.Description),
        InWriting: form.branch(data.InWriting),
        InPerson: form.branch(data.InPerson),
        GivenBy: form.name(data.GivenBy || {}),
        GivenByTelephone: form.collection(form.telephoneCollection(data.GivenByTelephone || {})),
        GivenByEmail: form.collection(form.emailCollection(data.GivenByEmail || {})),
      });
    };

    const assignments = (assignments) => (assignments?.items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          AssignedUnitOrg: form.text(yitem.AssignedUnitOrg),
          AssignedUnitOrgDateRange: form.daterange(yitem.AssignedUnitOrgDateRange),
          AssignedUnitOrgTelephone: form.telephone(yitem.AssignedUnitOrgTelephone),
          AssignedUnitOrgDutyStatus: form.text(yitem.AssignedUnitOrgDutyStatus),
          AssignedUnitOrgTitle: form.text(yitem.AssignedUnitOrgTitle),
          Has: form.branch(yitem.Has),
        },
      };
    });

    return {
      Item: {
        EmploymentActivity: form.employmentactivity(xitem.EmploymentActivity),
        MilitaryBranch: form.text(xitem.MilitaryBranch), // PVQ Only
        Assignments: form.collection(assignments(xitem.Assignments)),
        EmploymentActivityComments: form.textarea(xitem.EmploymentActivityComments),
        MilitaryEmploymentComments: form.textarea(xitem.MilitaryEmploymentComments),
        NonMilitaryEmploymentComments: form.textarea(xitem.NonMilitaryEmploymentComments),
        PhysicalAddressAnswerComments: form.textarea(xitem.PhysicalAddressAnswerComments),
        PhysicalAddressComments: form.textarea(xitem.PhysicalAddressComments),
        Comments: form.textarea(xitem.Comments),
        SelfEmploymentComments: form.textarea(xitem.SelfEmploymentComments),
        AddressPhysicalComments: form.textarea(xitem.AddressPhysicalComments),
        AddressAnswerComments: form.textarea(xitem.AddressAnswerComments),
        AddressComments: form.textarea(xitem.AddressComments),
        ReferenceComments: form.textarea(xitem.ReferenceComments),
        ReferenceAlternateAddressPhysicalComments: form.textarea(xitem.ReferenceAlternateAddressPhysicalComments),
        ReferenceAlternateAddressAnswerComments: form.textarea(xitem.ReferenceAlternateAddressAnswerComments),
        ReferenceAlternateAddressComments: form.textarea(xitem.ReferenceAlternateAddressComments),
        UnemploymentComments: form.textarea(xitem.UnemploymentComments),
        Dates: form.daterange(xitem.Dates),
        Employer: form.text(xitem.Employer),
        StillInBusiness: form.branch(xitem.StillInBusiness), // PVQ Only
        ReturnedToWork: form.branch(xitem.ReturnedToWork), // PVQ Only
        ReturnDate: form.daterange(xitem.ReturnDate), // PVQ Only
        HasAssociatedCompany: form.branch(xitem.HasAssociatedCompany), // PVQ Only
        SelfEmployedWebsite: form.text(xitem.SelfEmployedWebsite), // PVQ Only
        SelfEmployedWebsiteNotApplicable: form.notapplicable(xitem.SelfEmployedWebsiteNotApplicable), // PVQ Only
        SelfEmployedEmail: form.text(xitem.SelfEmployedEmail), // PVQ Only
        SelfEmployedEmailNotApplicable: form.notapplicable(xitem.SelfEmployedEmailNotApplicable), // PVQ Only
        IsHomeCompany: form.branch(xitem.IsHomeCompany), // PVQ Only
        Status: form.radio(xitem.Status),
        Title: form.text(xitem.Title),
        DutyStation: form.text(xitem.DutyStation),
        DutyStatus: form.text(xitem.DutyStatus), // PVQ Only
        Address: form.location(xitem.Address),
        AlternateAddress: form.physicaladdress(xitem.AlternateAddress),
        Additional: form.collection(
          ((xitem.Additional || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Position: form.text(yitem.Position),
                Supervisor: form.text(yitem.Supervisor),
                DatesEmployed: form.daterange(yitem.DatesEmployed),
              },
            };
          })
        ),
        Telephone: form.telephone(xitem.Telephone),
        ReasonLeft: form.reasonleft(xitem.ReasonLeft),
        Reprimand: form.collection(
          ((reprimand || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Text: form.textarea(yitem.Text),
                Date: form.datecontrol(yitem.Date),
                Comments: form.textarea(yitem.Comments),
                Consequences: form.checkboxgroup(yitem.Consequences), // PVQ Only
                ConsequencesOtherExplanation: form.textarea(yitem.ConsequencesOtherExplanation), // PVQ Only
                GivenBy: form.name(yitem.GivenBy), // PVQ Only
                GivenByNotApplicable: form.notapplicable(yitem.GivenByNotApplicable), // PVQ Only
                GivenByRank: form.text(yitem.GivenByRank), // PVQ Only
                RankUnknown: form.notapplicable(yitem.RankUnknown), // PVQ Only
                GivenByTelephone: form.collection(form.telephoneCollection(yitem.GivenByTelephone)), // PVQ Only
                GivenByEmail: form.collection(form.emailCollection(yitem.GivenByEmail)), // PVQ Only
                DisciplinaryAction: form.radio(yitem.DisciplinaryAction), // PVQ Only
                DisciplinaryActionOtherExplaination: form.textarea(yitem.DisciplinaryActionOtherExplaination) // PVQ Only
              },
            };
          })
        ),
        Supervisor: form.supervisor(xitem.Supervisor),
        SupervisorAlternateAddress: form.physicaladdress(xitem.SupervisorAlternateAddress),
        SupervisorAlternateAddressPhysicalComments: form.textarea(xitem.SupervisorAlternateAddressPhysicalComments),
        SupervisorAlternateAddressAnswerComments: form.textarea(xitem.SupervisorAlternateAddressAnswerComments),
        SupervisorAlternateAddressComments: form.textarea(xitem.SupervisorAlternateAddressComments),
        ReprimandComments: form.textarea(xitem.ReprimandComments),
        ReprimandAnswerComments: form.textarea(xitem.ReprimandAnswerComments),
        ReasonLeftComments: form.textarea(xitem.ReasonLeftComments),
        ReasonLeftAnswerComments: form.textarea(xitem.ReasonLeftAnswerComments),
        WasFired: form.branch(xitem.WasFired), // PVQ Only
        FiredDetails: dismissalItem(xitem.FiredDetails), // PVQ Only
        WasLeaveBeforeFired: form.branch(xitem.WasLeaveBeforeFired), // PVQ Only
        LeaveBeforeFiredDetails: dismissalItem(xitem.LeaveBeforeFiredDetails), // PVQ Only
        WasLeaveAfterNoticeMisconduct: form.branch(xitem.WasLeaveAfterNoticeMisconduct), // PVQ Only
        LeaveAfterNoticeMisconductDetails: dismissalItem(xitem.LeaveAfterNoticeMisconductDetails), // PVQ Only
        WasLeaveAfterNoticePerformance: form.branch(xitem.WasLeaveAfterNoticePerformance), // PVQ Only
        LeaveAfterNoticePerformanceDetails: dismissalItem(xitem.LeaveAfterNoticePerformanceDetails), // PVQ Only
        WasLeavePendingOutcome: form.branch(xitem.WasLeavePendingOutcome), // PVQ Only
        LeavePendingOutcomeDetails: dismissalItem(xitem.LeavePendingOutcomeDetails), // PVQ Only
        ReferenceName: form.name(xitem.ReferenceName),
        ReferencePhone: form.telephone(xitem.ReferencePhone),
        ReferenceAddress: form.location(xitem.ReferenceAddress),
        ReferenceAlternateAddress: form.physicaladdress(xitem.ReferenceAlternateAddress),
        PhysicalAddress: form.physicaladdress(xitem.PhysicalAddress),
        PhysicalAlternateAddress: form.physicaladdress(xitem.PhysicalAlternateAddress),
        PhoneNumbers: form.collection(phoneNumbers), // PVQ Only
        Emails: form.collection(emails), // PVQ Only
        Websites: form.collection(websites), // PVQ Only
        HasDifferentPhysicalWorkAddress: form.branch(xitem.HasDifferentPhysicalWorkAddress), // PVQ Only
        PhysicalWorkAddress: form.location(xitem.PhysicalWorkAddress), // PVQ Only
        IsInternship: form.branch(xitem.IsInternship), // PVQ Only
      },
    };
  });

  // PVQ Part B Only
  const foreignServiceItems = ((data.ForeignServiceList || {}).items || []).map((x) => {
    const xitem = x.Item || {};

    const foreignContacts = (foreignContacts) => (foreignContacts?.items || []).map((y) => {
      const yitem = y.Item || {};
      return {
        Item: {
          Name: form.name(yitem.Name),
          Rank: form.text(yitem.Rank),
          DateMet: form.datecontrol(yitem.DateMet),
          DateLastContacted: form.datecontrol(yitem.DateLastContacted),
          Frequency: form.radio(yitem.Frequency),
          FrequencyOtherExplanation: form.textarea(yitem.FrequencyOtherExplanation),
          Address: form.location(yitem.Address),
          AddressNotApplicable: form.notapplicable(yitem.AddressNotApplicable),
          InUsaNotApplicable: form.notapplicable(yitem.InUsaNotApplicable),
          Relationship: form.text(yitem.Relationship),
          Has: form.branch(yitem.Has),
        },
      };
    });

    return {
      Item: {
        Discipline: form.radio(xitem.Discipline),
        DisciplineOtherExplanation: form.textarea(xitem.DisciplineOtherExplanation),
        Country: form.country(xitem.Country),
        Agency: form.text(xitem.Agency),
        CivilianOrMilitary: form.radio(xitem.CivilianOrMilitary),
        HighestRank: form.text(xitem.HighestRank),
        Department: form.text(xitem.Department),
        HowAssociated: form.textarea(xitem.HowAssociated),
        DatesServed: form.daterange(xitem.DatesServed),
        ReasonLeft: form.textarea(xitem.ReasonLeft),
        ForeignContacts: form.collection(foreignContacts(xitem.ForeignContacts)),
      },
    };
  });

  return {
    EmploymentRecord: form.branch(data.EmploymentRecord),
    SummaryComments: form.textarea(data.SummaryComments),
    EmploymentRecordComments: form.textarea(data.EmploymentRecordComments),
    List: form.collection(items, (data.List || {}).branch),
    HasAdditionalSelfEmploymentEntry: form.branch(data.HasAdditionalSelfEmploymentEntry), // PVQ Only
    HasAdditionalUnemploymentEntry: form.branch(data.HasAdditionalUnemploymentEntry), // PVQ Only
    HasForeignService: form.branch(data.HasForeignService), // PVQ Part B Only
    ForeignServiceList: form.collection(foreignServiceItems, (data.ForeignServiceList || {}).branch), // PVQ Part B Only
  };
};
